<template>
  <div :class="['st-date-field', { 'st-date-field--datetime': withTime }]">
    <v-text-field
      v-bind="fieldProps"
      v-on="forwardedListeners"
      :id="id"
      :value="inputValue"
      :label="computedLabel"
      :disabled="disabled"
      :hide-details="hideDetails"
      :append-icon="appendIcon"
      :min="computedMin"
      :max="computedMax"
      :type="inputType"
      @input="onInput"
      @change="onChange"
      @click:append="clearValue"
    />
  </div>
</template>

<style scoped>
.st-date-field--datetime >>> input[type="datetime-local"] {
  position: relative;
  min-width: 14rem;
  padding-right: 2rem;
}

.st-date-field--datetime >>> input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  position: absolute;
  right: 0;
  margin: 0;
}
</style>

<script>
import src from './src'
export default src
</script>
